/* Página de producto de Escualo.
 *
 * Qué hace:
 *   - Cambia la foto grande al picar una miniatura.
 *   - Al elegir color/talla: actualiza precio, foto, botón y la URL.
 *   - Los botones − y + de la cantidad.
 *
 * Sin JavaScript, la página sigue sirviendo: el formulario es real y manda
 * la variante que venga seleccionada del servidor.
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-product]');
  if (!root) return;

  /* ---------- Galería ---------- */

  const stage = root.querySelector('[data-stage]');
  const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));

  function showThumb(thumb) {
    if (!stage || !thumb) return;
    stage.src = thumb.dataset.full;
    // srcset manda sobre src: hay que limpiarlo o el navegador lo ignora
    stage.srcset = '';
    thumbs.forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
    thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => showThumb(thumb));
  });

  function showThumbAt(step) {
    if (thumbs.length < 2) return;
    const current = thumbs.findIndex((t) => t.classList.contains('is-active'));
    const from = current === -1 ? 0 : current;
    const next = (from + step + thumbs.length) % thumbs.length;
    showThumb(thumbs[next]);
  }

  root.querySelector('[data-stage-prev]')?.addEventListener('click', () => showThumbAt(-1));
  root.querySelector('[data-stage-next]')?.addEventListener('click', () => showThumbAt(1));

  /* ---------- Tabs de info ---------- */

  root.querySelectorAll('[data-tabs]').forEach((tabs) => {
    const btns = tabs.querySelectorAll('[data-tab-btn]');
    const panels = tabs.querySelectorAll('[data-tab-panel]');
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tabBtn;
        btns.forEach((b) => b.classList.toggle('is-active', b === btn));
        panels.forEach((p) => p.classList.toggle('is-active', p.dataset.tabPanel === target));
      });
    });
  });

  /* ---------- Cantidad ---------- */

  const qtyInput = root.querySelector('[data-qty-input]');

  root.querySelectorAll('[data-qty-step]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      const step = parseInt(btn.dataset.qtyStep, 10);
      const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
      qtyInput.value = next;
    });
  });

  /* ---------- Variantes ---------- */

  const picker = root.querySelector('[data-variant-picker]');
  if (!picker) return;

  const dataEl = picker.querySelector('[data-variant-data]');
  if (!dataEl) return;

  let variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return; // Sin datos no hay nada que hacer; el formulario sigue funcionando
  }

  const idInput = root.querySelector('[data-variant-id]');
  const priceEl = root.querySelector('[data-price]');
  const addBtn = root.querySelector('[data-add-btn]');
  const addText = root.querySelector('[data-add-text]');
  const baseText = addText ? addText.dataset.base || addText.textContent.split('·')[0].trim() : '';

  if (addText) addText.dataset.base = baseText;

  function chosen() {
    const groups = picker.querySelectorAll('.vpick__group');
    return Array.from(groups).map((g) => {
      const checked = g.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant(selection) {
    return variants.find((variant) =>
      variant.options.every((opt, i) => opt === selection[i])
    );
  }

  // El tache de "agotado" que pinta Liquid en cada valor (data-unavailable /
  // is-unavailable) solo refleja la combinación con la que cargó la página.
  // Al cambiar de talla, por ejemplo, algunos colores pueden dejar de existir
  // en esa talla — sin esto, el botón se deshabilitaba pero el color se
  // seguía viendo como si sí se pudiera elegir. No se deshabilita el radio:
  // el cliente sigue pudiendo verlo/elegirlo a propósito, solo se marca.
  function updateOptionAvailability() {
    const selection = chosen();
    const groups = Array.from(picker.querySelectorAll('.vpick__group'));

    groups.forEach((group, groupIndex) => {
      Array.from(group.querySelectorAll('.vpick__input')).forEach((input) => {
        const candidate = selection.slice();
        candidate[groupIndex] = input.value;

        const hasAvailable = variants.some(
          (variant) => variant.available && variant.options.every((opt, i) => opt === candidate[i])
        );

        const label = group.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !hasAvailable);
      });
    });
  }

  function update() {
    const selection = chosen();
    const variant = findVariant(selection);

    // El nombre de la opción elegida, junto a "Color:"
    selection.forEach((value, i) => {
      const label = picker.querySelector('[data-option-current="' + (i + 1) + '"]');
      if (label && value) label.textContent = value;
    });

    if (!variant) {
      // Esa combinación no existe (p. ej. Rojo + XL nunca se fabricó)
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = 'No disponible';
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (priceEl) {
      // La insignia de porcentaje también se repinta: si no, se quedaba la
      // del primer variante al cambiar de color o talla (o desaparecía).
      let html = '';
      if (variant.on_sale) {
        html += '<s class="pdp__price-was">' + variant.compare_at_price + '</s>';
      }
      html += variant.price;
      if (variant.on_sale && variant.discount_pct > 0) {
        html += '<span class="pdp__price-off">-' + variant.discount_pct + '%</span>';
      }
      priceEl.innerHTML = html;
    }

    if (variant.image && stage) {
      stage.src = variant.image;
      stage.srcset = '';
      root.querySelectorAll('[data-thumb]').forEach((t) => {
        t.classList.toggle('is-active', t.dataset.full === variant.image);
      });
    }

    if (addBtn) addBtn.disabled = !variant.available;
    if (addText) {
      addText.textContent = variant.available
        ? baseText + ' · ' + variant.price + ' →'
        : 'Agotado';
    }

    // La URL sigue a la variante: así el cliente puede copiar el enlace del color que eligió
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  picker.addEventListener('change', () => {
    update();
    updateOptionAvailability();
  });
})();
